import React from "react";
import { X, Check } from "lucide-react";

const BAD = [
  { title: "High Street Banks", body: "Weeks of paperwork, months of waiting" },
  { title: "One-Product Lenders", body: "Wrong loan for the job — or a flat no" },
  { title: "Hidden Arrangement Fees", body: "Charges that appear at signing" },
  { title: "Personal Guarantees Everywhere", body: "Every director on the hook, always" },
];
const GOOD = [
  { title: "Indicative Offer in Hours", body: "Same-day terms · no waiting weeks" },
  { title: "Whole-Of-Market Panel", body: "Working capital · asset · property · invoice · growth" },
  { title: "Fees Disclosed Up-Front", body: "Nothing added at signing — ever" },
  { title: "PG-Light Options", body: "We prioritise structures that protect directors" },
];

export default function Comparison() {
  return (
    <section className="relative bg-paper-warm py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <SectionBadge>The SwiftCash difference</SectionBadge>
          <h2 className="font-display font-extrabold text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.035em] text-navy mt-5">
            Why UK businesses switch <br />
            <span className="text-emerald">to SwiftCash</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 lg:gap-6 max-w-5xl mx-auto">
          {/* Traditional */}
          <div className="rounded-[24px] bg-white border border-line p-7 md:p-8 relative">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-coral/10 text-coral font-mono text-[10.5px] uppercase tracking-[0.14em] font-bold mb-5">
              The Old Way
            </div>
            <h3 className="font-display font-extrabold text-[22px] md:text-[26px] text-navy tracking-[-0.025em] mb-7">
              Traditional Lenders
            </h3>
            <ul className="space-y-5">
              {BAD.map((b, i) => (
                <li key={i} className="flex items-start gap-4" data-testid={`compare-bad-${i + 1}`}>
                  <span className="h-9 w-9 rounded-full bg-coral/12 text-coral flex items-center justify-center shrink-0">
                    <X className="h-4 w-4" strokeWidth={3} />
                  </span>
                  <div>
                    <div className="font-display font-extrabold text-[15.5px] text-navy tracking-[-0.015em] mb-0.5">{b.title}</div>
                    <div className="text-[14px] text-navy/60 font-medium">{b.body}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* SwiftCash */}
          <div className="rounded-[24px] bg-navy border border-navy p-7 md:p-8 text-white relative overflow-hidden">
            <div className="absolute -top-32 -right-32 h-72 w-72 rounded-full bg-emerald/15 blur-3xl pointer-events-none" />
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald text-white font-mono text-[10.5px] uppercase tracking-[0.14em] font-extrabold mb-5 relative">
              The SwiftCash way
            </div>
            <h3 className="font-display font-extrabold text-[22px] md:text-[26px] tracking-[-0.025em] mb-7 relative">
              SwiftCash
            </h3>
            <ul className="space-y-5 relative">
              {GOOD.map((g, i) => (
                <li key={i} className="flex items-start gap-4" data-testid={`compare-good-${i + 1}`}>
                  <span className="h-9 w-9 rounded-full bg-emerald flex items-center justify-center shrink-0">
                    <Check className="h-4 w-4 text-white" strokeWidth={3.2} />
                  </span>
                  <div>
                    <div className="font-display font-extrabold text-[15.5px] tracking-[-0.015em] mb-0.5">{g.title}</div>
                    <div className="text-[14px] text-white/65 font-medium">{g.body}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionBadge({ children }) {
  return (
    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-soft text-emerald-3 font-mono text-[10.5px] uppercase tracking-[0.2em] font-bold">
      <span className="h-1.5 w-1.5 rounded-full bg-emerald" />
      {children}
    </div>
  );
}
